module.exports = __webpack_public_path__ + "static/favicon/favicon-16x16.png";